import Vue from 'vue';
import mock from '../countries-data.json';
import langsMock from '../languages.json';

const state = {

    // -------- Langs -------
    isSearchingLangs: false,

    filteredLangs: [],

    langs: [],

    countries: {},

    originalLangs: () => {
        let langs = langsMock.languages.map(o => (({ language_code, language_name, country_code }) => ({ language_code, language_name, country_code }))(o));
        langs.map(l => l.selected = model.currentCampaignObj.campaignLangs.indexOf(l.language_code) > -1);
        return langs;
    },

    initialLangs: () => {
        return state.originalLangs().filter((v, i, a) => a.findIndex(t => (t.language_code === v.language_code)) === i);
    },

    initialCountries: () => {
        return mock.countries;
    },

    includedLangs: [],

    excludedLangs: [],

};

const getters = {

    // -------- Languages -------
    langs(state) {
        return state.langs;
    },

    filteredLangs(state) {
        return state.filteredLangs;
    },

    countries(state) {
        return state.countries;
    },

    isSearchingLangs(state) {
        return state.isSearchingLangs;
    },

    includedLangs(state) {
        return state.includedLangs;
    },

    excludedLangs(state) {
        return state.excludedLangs;
    },

    initialCountries(state) {
        return state.initialCountries;
    },
    // --------------------------

};

const mutations = {

    // -------- Langs -------
    initLangs(state) {
        state.langs = state.initialLangs();
        state.filteredLangs = state.initialLangs().filter((v, i, a) => a.findIndex(t => (t.language_name === v.language_name)) === i);
        state.countries = state.initialCountries();
        state.includedLangs = [...state.filteredLangs.filter(l => model.currentCampaignObj.campaignLangs.indexOf(l.language_code) > -1)];

        state.includedLangs.map(l => l.selected = model.currentCampaignObj.campaignLangs.indexOf(l.language_code) > -1);

    },

    selectLang(state, { item, selected }) {
        if (item) {
            //const langs = [...state.filteredLangs];

            const lang = state.langs.filter(l => l.language_code === item.language_code)[0];
            //lang.selected = selected || !lang.selected;
            lang.selected = selected;
            //state.filteredLangs = [...state.langs ];
            const includedLangs = [ ...state.includedLangs ];
            const index = includedLangs.map(l => l.language_code).indexOf(lang.language_code);
            if (lang.selected) {
                if (index === -1) {
                    includedLangs.push(lang);
                }
            } else {
                includedLangs.splice(index, 1);
            }
            state.includedLangs = [...includedLangs];

            let flang = state.filteredLangs.find(f => f.language_code == lang.language_code);
            if (flang) flang.selected = selected;

            let campaignLangs = [];
            model.currentCampaignObj.campaignLangs = '';
            includedLangs.forEach(lang => {
                campaignLangs.push(lang.language_code);
            });
            // state.selectedLangsRadioButton = state.includedLangs.length ? 2 : 1;
            model.currentCampaignObj.campaignLangs = campaignLangs.join(',');

            cmGlobalScope.languages_selection_is_valid = !(this.selectedLangsRadioButton === 2 && model.currentCampaignObj.campaignLangs.length == 0);

            if (_isAdmin) { window.appCampaignDoughnut.$emit('calcChartRates'); }
        }
    },

    clearLangsSearch() {
        this.filteredLangs = state.initialLangs();
    },



    searchLangs(state, toSearch) {
        this.isSearchingLangs = true;

        toSearch = toSearch.toLowerCase();
        const langs = state.initialLangs();

        state.filteredLangs = langs.filter(l => !!toSearch ? l.language_name.toLowerCase().indexOf(toSearch.toLowerCase()) != -1 : true);

        state.filteredLangs = state.filteredLangs.map((l) => {
            l.selected = state.includedLangs.findIndex(y => y.language_code.indexOf(l.language_code) > -1) > -1;
            return l;
        });

        this.isSearchingLangs = false;
    },


};

const actions = {

    // -------- Langs -------
    searchLangs(context, payload) {
        context.commit('searchLangs', payload);
    },

    updateLangs(context, payload) {
        let selectedLangsRadioButton = payload;
        cmGlobalScope.languages_selection_is_valid = !(selectedLangsRadioButton === 2 && model.currentCampaignObj.campaignLangs.length == 0);
    
    },

    fillLangsByLocations(context) {

        const countryCodes = {}
        model.selected_locations.include.forEach(location => {
            if (location.country_code) {
                const locationCode = location.country_code;
                countryCodes[locationCode] = (countryCodes[locationCode] || 0) + 1;
            }
        });

        const selectedLangs = {}
        this.selectedLangsRadioButton = 2;
        const langs = context.state.originalLangs();
        for (const key in countryCodes) {
            langs.forEach(item => {
                if (item.country_code === key) {
                    selectedLangs[item.language_code] = (selectedLangs[item.language_code] || 0) + 1;
                    if (selectedLangs[item.language_code] <= 1) {
                        item.selected = true;
                        context.commit('selectLang', { item, selected: true });
                    };
                };
            });
        }

    },
   
    // ----------------------
};

export default {
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/components/Campaign/Targeting/Langs/store/langsStore.js